<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          id="btn_add_device_to_log"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ReportDeviceLogs />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ReportDeviceLogs from '@/components/reports/devicelogs/DeviceLogs'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'ReportDeviceLogsView',
  components: {
    PageTitle,
    PageRowWrapper,
    ReportDeviceLogs,
    ActionButton
  }
}
</script>
